import HttpBaseService from '@/services/http/HttpBaseService'

class ProfileService extends HttpBaseService {

  fetchProfile = async (payload) => {
    const response = await this.executeRequest('/api/me', 'GET', payload)
    return response.data
  }

  logout = async () => {
    const response = await this.executeRequest('/api/me/logout', 'GET')
    return response.data
  }

  requestLogin = (payload) => {
    return this.executeRequest('/api/me/generate-login', 'POST', payload, true)
  }

  login = async ({ email, code }) => {
    const response = await this.executeRequest(`/api/me/login`, 'POST', {'email': email, 'code': code})
    return response.data
  }

  onboardingCompleted = async () => {
    const response = await this.executeRequest(`/api/me/onboarding-completed`, 'POST')
    return response.data
  }

  getReservations = () => {
    return this.executeRequest('/api/me/reservations', 'GET')
  }

  getCurrentReservationGroup = () => {
    return this.executeRequest('/api/me/reservation-group', 'GET')
  }

  fetchPreCheckins = () => {
    return this.executeRequest('/api/me/pre-checkins', 'GET')
  }

}

export default new ProfileService()
